/**
 * «Не получилось» — отметка пропуска с причиной.
 *
 * Причина обязательна: родителю важно получить объяснение, а не тишину,
 * а няне — возможность сказать это один раз, а не оправдываться вечером.
 */

import { useState } from 'react'

import { useSkipTask, type ScheduleTask } from '@/shared/api/schedule'
import { Button } from '@/shared/ui/Button'
import { Sheet } from '@/shared/ui/Sheet'
import { Field, TextInput } from '@/shared/ui/fields'
import { toast } from '@/shared/ui/toast'

/** «Не получилось» — с причиной: родитель увидит объяснение, а не тишину. */
export function SkipSheet({
  task,
  familyId,
  onClose,
}: {
  task: ScheduleTask | null
  familyId: number
  onClose: () => void
}) {
  const [reason, setReason] = useState('')

  const skip = useSkipTask(familyId, {
    onSuccess: () => {
      toast.show('Отмечено, родители увидят причину')
      setReason('')
      onClose()
    },
    onError: (error) => toast.error(error.message),
  })

  return (
    <Sheet
      open={task !== null}
      onClose={() => {
        setReason('')
        onClose()
      }}
      title={task ? `Не получилось: ${task.title}` : ''}
      footer={
        <Button
          block
          size="lg"
          loading={skip.isPending}
          disabled={!reason.trim()}
          onClick={() => task && skip.mutate({ id: task.id, reason: reason.trim() })}
        >
          Отправить
        </Button>
      }
    >
      <Field
        label="Что случилось"
        hint="Коротко, своими словами — это снимает лишние вопросы вечером."
      >
        <TextInput
          value={reason}
          onChange={(event) => setReason(event.target.value)}
          placeholder="Бассейн закрыли на ремонт"
          maxLength={200}
          autoFocus
        />
      </Field>
    </Sheet>
  )
}
